export enum RegepProvisioningType {
  PickUpAt = 'PickUpAt',
  Shipping = 'Shipping',
}
